import MessageBox from './src/main.js';
export default MessageBox;
